import { Box, Card, useMediaQuery, useTheme } from "@mui/material";
import { H6, H7, Tiny } from "components/Typography";
import avatar5 from "assets/avatar-5.png";

const userData = {
  id: "chaeun",
  name: "디자이너 채은",
  profilePhoto: avatar5,
  followers: 890,
  following: 567,
  posts: 89,
  progress: 60,
};

export default function ProfileCard() {
  const theme = useTheme();
  const isLaptop = useMediaQuery(theme.breakpoints.down("lg"));

  return (
    <Card
      sx={{
        padding: 1.5,
        height: "100%",
        borderRadius: isLaptop ? 0 : 2,
        border: "none",
      }}
    >
      <Box
        width="100%"
        alignItems="center"
        justifyContent="space-between"
        textAlign="center"
      >
        <Box mb={3}>
          <Box
            sx={{
              width: 130,
              height: 130,
              margin: "0 auto",
              position: "relative",
            }}
          >
            <svg width="130" height="130" viewBox="-10 -10 130 130">
              <defs>
                <clipPath id="hexagonClip">
                  <path d="M55 11 L94 33 V75 L55 97 L16 75 V33 Z" />
                </clipPath>
                <linearGradient
                  id="progressGradient"
                  x1="0%"
                  y1="0%"
                  x2="100%"
                  y2="0%"
                >
                  <stop offset="0%" stopColor={"#B187FF"} />
                  <stop offset="100%" stopColor={"#5C92D2"} />
                </linearGradient>
              </defs>
              <path
                d="M55 3 L100 28 V79 L55 104 L10 79 V28 Z"
                fill="none"
                stroke="#e0e0e0"
                strokeWidth="6"
              />
              <path
                d="M55 3 L100 28 V79 L55 104 L10 79 V28 Z"
                fill="none"
                stroke="url(#progressGradient)"
                strokeWidth="6"
                strokeDasharray="372"
                strokeDashoffset={372 - (372 * userData.progress) / 100}
                strokeLinecap="round"
              />
              <image
                href={userData.profilePhoto}
                x="16"
                y="11"
                width="78"
                height="86"
                clipPath="url(#hexagonClip)"
                preserveAspectRatio="xMidYMid slice"
              />

              {/* Number 4 in a circle */}
              <circle cx="95" cy="75" r="12" fill="#5C92D2" />
              <text
                x="95"
                y="76"
                fontFamily="Arial, sans-serif"
                fontSize="14"
                fontWeight="medium"
                fill="white"
                textAnchor="middle"
                dominantBaseline="middle"
              >
                4
              </text>
            </svg>
          </Box>
          <H6 mt={1}>{userData.name}</H6>
          <H7 mt={1}>@{userData.id}</H7>
          <Box display="flex" justifyContent="space-around" mt={2}>
            {[
              { label: "팔로워", value: userData.followers },
              { label: "팔로잉", value: userData.following },
              { label: "게시물", value: userData.posts },
            ].map((item, index) => (
              <Box key={index}>
                <H6>{item.value}</H6>
                <Tiny>{item.label}</Tiny>
              </Box>
            ))}
          </Box>
        </Box>
      </Box>
    </Card>
  );
}
